<template>
  <div
    v-if="data"
    class="not-edit-item"
  >
    <div
      v-if="value && $toType(value) === 'array' && value.length"
      :class="data.fieldtype + '-box'"
      class="arr"
    >
      <template v-if="data.fieldtype === 'tag'">
        <span
          v-for="(tag, i) in value"
          :key="i"
          class="tag"
        >{{ tag }}</span>
      </template>
      <template v-else-if="data.fieldtype === 'file'">
        <a
          v-for="(file, i) in value"
          :key="i"
          class="file"
          @click="handleclickGallery(value, i)"
        >{{ file.file_name }}</a>
      </template>
      <template v-else>
        <span>{{ value.join(',') }}</span>
      </template>
    </div>
    <div
      v-else-if="$toType(value) === 'object'"
      :class="data.fieldtype + '-box'"
    >
      <template v-if="data.fieldtype === 'select_tree'">
        <span
          v-if="!Object.keys(value).length || value.input === '' && !value.treedata.length"
          class="tree-input"
        >
          - -
        </span>
        <span
          v-if="value.input"
          class="tree-input"
        >
          {{ value.input }}
        </span>
        <span
          v-for="(tag, i) in value.treedata"
          :key="i"
          class="tag"
        >{{ tag }}</span>
      </template>
      <template v-else-if="data.fieldtype === 'area'">
        <div v-if="!value.code && !value.address">
          - -
        </div>
        <div v-else>
          <span
            v-if="value.code && Object.values(value.code).length"
            class="code"
          >{{ Object.values(value.code).join('/') }}</span>
          <span class="address">{{ value.address }}</span>
        </div>
      </template>
    </div>
    <div
      v-else-if="$toType(value) === 'string'"
      :class="data.fieldtype + '-box'"
    >
      <div
        v-if="data.fieldtype === 'editor'"
        class="editor quill-editor"
        :class="{'empt': value === '- -'}"
      >
        <div v-html="$xss(value, $xssOptions)" />
      </div>
      <div
        v-else
        class="text-value"
      >
        {{ value || '- -' }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      value: ''
    }
  },
  watch: {
    data: {
      handler (val) {
        this.setItem()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.setItem()
  },
  methods: {
    setItem () {
      let { fieldtype = '', fieldvalue, valuenames, fieldvaluedesc, options = [], fieldconfig = {} } = this.data || {}
      switch (fieldtype) {
        case 'string':
        case 'text':
        case 'number':
        case 'ip':
        case 'datetime':
        case 'editor':
          this.value = fieldvalue || '- -'
          break
        case 'phone':
        case 'email':
        case 'tag':
          this.value = fieldvalue || []
          if (!this.value.length) {
            this.value = '- - '
          }
          break
        case 'file':
          fieldvalue.map(item => {
            item.description = item.file_name
            item.href = item.file_url
            item.title = this.$t('message["1304"]')

            return item
          })
          this.value = fieldvalue || []
          if (!this.value.length) {
            this.value = '- - '
          }
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_type':
        case 'radioinfo_followup':
          if (this.$toType(options) === 'object') {
            options = _.reduce(options, (res, item) => {
              res.push(item)
              return res
            }, [])
          }
          this.value = this.optionGetValue(fieldvalue, options)
          break
        case 'radioinfo_level':
          const { type } = fieldconfig

          if (fieldvalue === '') {
            this.value = '- -'
            break
          }

          if (type === 1) {
            options = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
          } else if (type === 2) {
            options = this.$t('message["1444"]').split(',')
          }
          options.forEach((item, index) => {
            if (fieldvalue - 1 === index) {
              this.value = item || '- -'
            }
          })
          break
        case 'checkbox':
          this.value = this.optionGetValues(fieldvalue, options)
          break
        case 'select_tree':
          this.value = fieldvaluedesc || {}
          break
        case 'area':
          this.value = fieldvalue || {}
          break
        case 'select_reception':
          if (valuenames) {
            this.value = valuenames.length ? valuenames.join('/') : '- -'
          } else {
            this.value = fieldvalue
          }
          break
        default:
          this.value = fieldvalue || '- -'
          break
      }
    },

    optionGetValue (value, options) {
      if (!options || !options.length) return '- -'

      const filter = options.filter(item => item.id === value)
      return (filter[0] && filter[0].name) || '- -'
    },

    optionGetValues (values, options) {
      if (!options || !options.length) return '- -'

      const filter = options.filter(item => {
        for (let value of values) {
          if (item.id === value) {
            return item
          }
        }
      })
      return filter.map(item => item.name)
    },

    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.not-edit-item {
  overflow: auto;
  min-height: 56px;
  line-height: 56px;
}
.tag {
  display: inline-block;
  margin-right: 16px;
  padding: 2px 4px;
  line-height: 1.2;
  font-size: 12px;
  color: #fff;
  background-color: #5077aa;
  border-radius: 4px;
}
.area-box .code {
  margin-right: 16px;
}
.tree-input {
  margin-right: 16px;
}
.editor-box ::v-deep {
  width: 260px;
  padding: 12px 0;
  line-height: normal;
  .editor {
    overflow: auto;
    max-height: 300px;
    margin: 10px 0;
    padding: 10px;
    word-break: break-all;
    border: solid 1px #ebebeb;
    border-radius: 4px;
  }
  .empt {
    margin: 0;
    padding: 0;
    border: none;
  }
  ol, ul {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  ol li {
    list-style: decimal;
  }
  ul li {
    list-style: initial;
  }
  img {
    display: inline-block;
    max-width: 100%;
  }
  strong {
    font-weight: bold;
  }
}
.file-box {
  a {
    display: block;
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.text-box {
  .text-value {
    // width: 260p;
    padding: 16px 0;
    line-height: 24px;
    word-break: break-all;
  }
}
</style>
